import type { SentinelChannel } from '@/types/sentinelAnalytics';

/** Tooltip copy for every metric: one short, plain sentence, like Brand Health's. */
export const METRIC_HELP = {
  totalTickets: 'All support tickets the brand received in this period.',
  split: 'In scope: tickets Kim is contracted to handle. Out of scope: tickets outside Kim’s contract.',
  ticketSplit: 'Share of tickets that were in scope, by day.',
  unassignment: 'Share of tickets marked in-scope that turned out to be out of scope and were unassigned.',
  missedOpportunity: 'Share of in-scope tickets Kim didn’t handle.',
  ticketsHandled: 'In-scope tickets Kim worked on, alone or with Sentinel help.',
  automation: 'Share of handled tickets Kim resolved with no human touch.',
  reopen: 'Share of resolved tickets reopened within 7 days.',
  ftnr: 'Share of resolved tickets reopened because the issue wasn’t fully solved. Excludes reopens like a thank-you.',
  csat: 'Average rating customers gave after their issue was solved, from 1 to 5 stars.',
  csatResponse: 'Share of customers who left a rating, out of those asked.',
  firstResponse: 'Time from the customer’s first message to the first real reply.',
  resolution: 'Time from ticket creation until it’s marked resolved.',
  effort: 'Replies that needed human effort vs replies Kim sent with no human effort.',
  correctedResponses: 'Kim responses a Sentinel edited before sending.',
  accurateResponses: 'Kim responses that were correct and sent with no edits.',
  aiAccuracy: 'Share of Kim responses that were accurate. Accurate responses ÷ All Kim responses.',
  aiAccuracyTrend: 'AI accuracy rate for each day in the period.',
  aiCoverage: 'Share of in-scope replies where Kim generated a response.',
  aiGenerationFailure: 'Replies where Kim tried but couldn’t produce a usable response.',
  oversightPrompts: 'Corrected responses grouped by how many instructions a Sentinel gave Kim to fix them: 1–2, or more than 2.',
} as const;

export type MetricHelpKey = keyof typeof METRIC_HELP;

/** Same token the backend uses for tickets with no category. */
export const UNCATEGORIZED_CATEGORY = 'Uncategorized';

/** Channel filter options, in kim-analytics' order. */
export const CHANNELS: SentinelChannel[] = ['email', 'live_chat', 'api', 'whatsapp', 'sms', 'facebook', 'instagram', 'telegram', 'line', 'other'];
export const CHANNEL_LABEL: Record<SentinelChannel, string> = {
  email: 'Email',
  live_chat: 'Live chat',
  api: 'API',
  whatsapp: 'WhatsApp',
  sms: 'SMS',
  facebook: 'Facebook',
  instagram: 'Instagram',
  telegram: 'Telegram',
  line: 'LINE',
  other: 'Other',
};
